import useWorkspace from "../../../../api/api-hooks/workspaces/useWorkspace";
import { SidebarItem } from "../../../Sidebar/CustomLinks/CustomLinks2";

interface Props {
  data: SidebarItem;
  draggableProps: any;
  open: boolean;
}

export default function EmptyTreeItem({ data, open }: Props) {
  return (
    <span>
      {data.Type === "Empty" &&
        (open ? (
          <div
            className="pl-3 ml-1 pt-1 pb-2 text-dark -cursor-pointer"
            style={{ fontSize: 12, cursor: "default" }}
          >
            Folder is empty.
          </div>
        ) : (
          <div className="d-flex justify-content-center py-2">&nbsp;</div>
        ))}
      {data.Type === "EmptySidebar" && <EmptySidebar open={open} />}
    </span>
  );
}

function EmptySidebar({ open }: { open: boolean }) {
  const { workspaceLoading, workspace } = useWorkspace();

  if (workspaceLoading || !open)
    return <div className="d-flex justify-content-center py-3"></div>;

  return (
    <div
      className="pl-3 mx-2 -cursor-pointer py-2 my-1 font-weight-500 bg-primary text-white rounded"
      style={{ fontSize: 13 }}
    >
      {!workspace?.Sidebar?.length
        ? "Add your first page to get started."
        : "Select an App to get started."}
    </div>
  );
}
